import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Form, Spinner } from "react-bootstrap";
import MultiSelect from '../../MultiSelect/MultiSelect';
import TableComponentPagepay from "../Table/TablePayment";
import TableComponentPage4 from "../Table/GroupTable";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import { useSelector } from 'react-redux';

function UserInvoice() {
  const [loadingAffilateInvoice, setLoadingAffilateInvoice] = useState(false)
  const [affilateInvoiceFilter, setAffilateInvoiceFilter] = useState({
    filters: {
      period: [],
      affiliategroup: [],
      commissiongroup: [],
      affiliateid: "",
      invoicetype: "",
      invoicestatus: "",
      invoiceid: ""
    }
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [AffilateInvoicePages, setAffilateInvoicePages] = useState(1);
  const [affiliateInvoices, setAffilateInvoices] = useState([])
  const [selectedRows, setSelectedRows] = useState([]);
  const [ltComGrp, setLtComGrp] = useState([])
  const [ltAffGrp, setLtAffGrp] = useState([])
  const [affiliateInvoiceStatus, setAffiliateInvoiceStatus] = useState({
    status: 0
  })
  const [resetTable, setResetTable] = useState(false);
  const [loading, setloading] = useState(false)
  const [dateTimeRange, setDateTimeRange] = useState({
    startDate: '',
    endDate: ''
  });
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [invoicingPermission, stInvoicingPermisssion] = useState(false)
  const columns = React.useMemo(
    () => [
      {
        Header: " ID",
        accessor: "id", // accessor is the "key" in the data
      },
      {
        Header: "Currency",
        accessor: "currency",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => {
          var statusText;
          if (value == 0) statusText = "Pending"
          else if (value == 1) statusText = "Submit for payment"
          else if (value == 3) statusText = "Paid ( Manually )"
          else if (value == 4) statusText = "Paid"
          else {
            statusText = "Carry over the next period"
          }
          return <span >{statusText}</span>
        },
      },
      {
        Header: "Affiliate ID",
        accessor: "affiliateid",
      },
      {
        Header: "Username",
        accessor: "username",
      },
      {
        Header: "Period",
        accessor: "period",
      },
      {
        Header: "Type",
        accessor: "type",
      },
      {
        Header: "Payment Amount",
        accessor: "paymentamount",
      },
      {
        Header: "Account Number",
        accessor: "accountnumber",
      },
      {
        Header: "Transaction ID",
        accessor: "transactionid",
      },
      {
        Header: "Players",
        accessor: "players",
      },
    ],
    []
  );
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  useEffect(() => {
    stInvoicingPermisssion(checkPermission(affliate, "pay_actions_with_invoices"));
  }, [affliate])
  const getAffiliateInvoices = async () => {
    setSelectedRows([]);
    setResetTable(!resetTable);
    setLoadingAffilateInvoice(true)
    const response = await axios.post(window.__CFG.API + "payments/GetAffiliateInvoices?page=" + currentPage, affilateInvoiceFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setLoadingAffilateInvoice(false)
    if (response.data.Error == null) {
      setAffilateInvoices(response.data.Result.Data);
      setAffilateInvoicePages(response.data.Pages)
    }
    else {
      setAffilateInvoices([]);
    }

  }
  const submitAffiliateAction = async () => {
    setloading(true)
    if (selectedRows.length > 0) {
      selectedRows.forEach(async sr => {
        const response = await axios.post(window.__CFG.API + "payments/SubmitInvoice/" + sr.id, affiliateInvoiceStatus, {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem("raff-token")
          }
        })
        if (response.data.Error == null) {
          getAffiliateInvoices();
          
          toast.success("Saved Sucessufully", {
            duration: 4000
          });
        }
        else {
          toast.error(response.data.Error, {
            duration: 4000
          })
        }
        setloading(false)
      })
    }
    else {
      toast.error("Please select a row", {
        duration: 4000
      })
    }
  }

  const handleSelectionCommissionChange = (selectedItems) => {
    setAffilateInvoiceFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, commissiongroup: selectedItems } }))
  };
  const handleSelectionaffiliateChange = (selectedItems) => {
    setAffilateInvoiceFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliategroup: selectedItems } }))
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSelectedRowsChange = (selectedRows) => {
    setSelectedRows(selectedRows);
  }
  useEffect(() => {
    if (currentPage != 1)
      getAffiliateInvoices()
  }, [currentPage])
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSelectPeriodChange = (e) => {
    const selectedValue = e.value;
    const today = new Date();
    let startDate = '';
    let endDate = '';

    switch (selectedValue) {
      case 'today':
        startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
        break;
      case 'yesterday':
        const yesterday = new Date(today.setDate(today.getDate() - 1));
        startDate = formatDate(new Date(yesterday.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(yesterday.setHours(23, 59, 59, 999)));
        break;
      case 'currentmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
        endDate = formatDate(today);
        break;
      case 'lastmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
        endDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 0));
        break;
      case 'currentyear':
        startDate = formatDate(new Date(today.getFullYear(), 0, 1));
        endDate = formatDate(today);
        break;
      case 'lastyear':
        startDate = formatDate(new Date(today.getFullYear() - 1, 0, 1));
        endDate = formatDate(new Date(today.getFullYear() - 1, 11, 31));
        break;
      default:
        startDate = '';
        endDate = '';
    }
    setDateTimeRange({ startDate, endDate });

  }
  const setTodayAsDefault = () => {
    const today = new Date();
    const startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
    const endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
    setDateTimeRange({ startDate, endDate });
  };
  useEffect(() => {
    setTodayAsDefault();
  }, []);
  useEffect(() => {
    var period = []
    var paymentHistory = Object.assign({}, affilateInvoiceFilter)
    if (dateTimeRange.startDate != "" && dateTimeRange.endDate != "") {
      period.push(dateTimeRange.startDate)
      period.push(dateTimeRange.endDate)
    }
    paymentHistory.filters.period = period;
    setAffilateInvoiceFilter(paymentHistory)
  }, [dateTimeRange])
  const getListAffliateGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtAffGrp(response.data.Result)
    }
  }
  const getListCommissionGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtComGrp(response.data.Result)
    }
  }
  useEffect(() => { getListAffliateGrp(); getListCommissionGrp(); }, [])
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const optionsPeriods = [{ label: "Today", value: "today" }, { label: "Yesterday", value: "yesterday" }, { label: "Current month", value: "currentmonth" }, { label: "Last month", value: "lastmonth" }, { label: "Current year", value: "currentyear" }, { label: "Last year", value: "lastyear" }, { label: "Custom", value: "custom" },]
  const optionsActions = [{ label: "Pay", value: 3 }, { label: "Submit for payment", value: 1 }, { label: "Carry over the next period", value: 2 }]
  const optionsInvoiceType = [{ label: "All", value: "" }, { label: "Automatic Weekly Invoicing", value: "0" }, { label: "Automatic Monthly Invoicing", value: "1" }];
  const optionsInvoiceStatus = [{ label : "Pending", value : "0" }, { label : "Submit for payment", value : "1" }, { label : "Paid", value : "4" }, { label : "Paid ( Manually )", value : "3" }, { label : "Carry over the next period", value : "2" }]
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)
  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4 className="text-start mt-5">Affiliate Invoices</h4>



            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-between  mt-4 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Period</label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsPeriods} onChange={handleSelectPeriodChange} defaultValue={{ label: "Today", value: "today" }} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Invoice type </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsInvoiceType} onChange={e => { setAffilateInvoiceFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, invoicetype: e.value } })) }} />
                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-between  mt-2 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Currency </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">

                    <Select options={optionsCurrency} value={selectedCurrencyValue} />

                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Invoice status </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsInvoiceStatus} onChange={e => { setAffilateInvoiceFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, invoicestatus: e.value } })) }} />
                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-between  mt-2 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>commission group</label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <MultiSelect options={ltComGrp} onSelectionChange={handleSelectionCommissionChange} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={5}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label> invoice id </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type='text' value={affilateInvoiceFilter.filters.invoiceid} onChange={e => { setAffilateInvoiceFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, invoiceid: e.target.value } })) }} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between  mt-2 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Affiliate group</label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <MultiSelect options={ltAffGrp} onSelectionChange={handleSelectionaffiliateChange} />

                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={4} className=" pt-2 md-se-btn">
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                  </div>
                  <div className="form-cre-grp-fl-wp-in md-se-btn">
                    <Button onClick={getAffiliateInvoices} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                      {loadingAffilateInvoice ? (<> <Spinner size="sm"></Spinner></>) : (<>
                        Generate report

                      </>)}
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
            <div
              style={{
                borderBottom: "1px dashed black",
                marginTop: "20px",
                width: "100%",
              }}
            ></div>

            <Row className="mt-2   mb-4">
              <Row style={{ marginTop: 10, paddingBottom: 5 }} className="justify-content-between mt-4 me-auto w-100">
                <Col lg={3} md={4} sm={4}>
                  <div className="form-cre-grp-fl-wp-in" >
                    <div style={{ paddingBottom: 11 }} className='add-affiliate-searchInput'>
                      <div style={{ position: "absolute" }} className="search-container">
                        <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 3, minWidth: 220 }} type="text" className="search-input" placeholder="Search" />
                        <i class="fa-solid fa-magnifying-glass" style={{ position: "absolute", right: 10, top: 8 }}></i>
                      </div>
                    </div>
                  </div>
                </Col>

              </Row>
              <div className="aff-dash-summary-table full-payment-report-table">
                <TableComponentPage4 key={resetTable} columns={columns} data={affiliateInvoices} onSelectedRowsChange={handleSelectedRowsChange} Pages={AffilateInvoicePages} currentPage={currentPage} onPageChange={handlePageChange} loading={loadingAffilateInvoice} />
              </div>
            </Row>

            <Row className="justify-content-start  mt-5  w-100">
              <Col lg={4} md={4} sm={5}>
                <div className='form-aff-list-in'>
                  <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                    <label>Action with selected</label>
                  </div>
                  <div className="dashboard-select-periode" style={{ maxWidth: "100%" }}>
                    <Select options={optionsActions} onChange={(e) => { setAffiliateInvoiceStatus({ ...affiliateInvoiceStatus, status: e.value }) }} />
                  </div>
                </div>
              </Col>

            </Row>

            <Row className="justify-content-start  mt-0 w-100 mb-5">

              <Col lg={4} md={4} sm={5} className=" pt-2 md-se-btn">
                <Button disabled={loading} onClick={submitAffiliateAction} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark  btn-com-grp">
                  {loading ? (<> <Spinner size="sm"></Spinner></>) : (<>
                    Apply

                  </>)}
                </Button>
              </Col>
            </Row>

          </Col>
        </Row>
      </Container>
    </>
  );
}

export default UserInvoice;




